export const loadingStateStyles = {
	tabsRow: 'mb-6 flex flex-wrap gap-3',
	listContainer: 'flex flex-col gap-6',
	card: 'flex gap-4 items-stretch',
	cardInfo: 'flex flex-1 flex-col justify-center gap-2 min-w-0 py-1',
	cardActions: 'flex flex-col items-end justify-between py-1'
} as const;
